import { getUserRole } from "./userRoleHelper";

export const hasCorrectLicence = (licence, licences) =>
{
  if (!licence.length) { return true; }
  return licences.find(
    (l) =>
    {
      return (licence.indexOf(l.code) > -1);
    }
  );
};

export const hasCorrectRole = (requiredRoles, name) =>
{
  const userRole = getUserRole();
  if (name)
  {
    console.log('correctRole', name, userRole, requiredRoles);

  }
  if (!requiredRoles.length) { return true; }
  console.log(requiredRoles.includes(userRole));
  return requiredRoles.includes(userRole);

};
